import { DOCUMENT } from '@angular/common';
import { inject, Injectable } from '@angular/core';

const ACCESS_TOKEN_KEY = 'nexo.accessToken';

@Injectable({
  providedIn: 'root',
})
export class TokenStorageService {
  private readonly document = inject(DOCUMENT);

  getToken(): string | null {
    return this.storage?.getItem(ACCESS_TOKEN_KEY) ?? null;
  }

  setToken(token: string): void {
    this.storage?.setItem(ACCESS_TOKEN_KEY, token);
  }

  clearToken(): void {
    this.storage?.removeItem(ACCESS_TOKEN_KEY);
  }

  private get storage(): Storage | null {
    return this.document.defaultView?.sessionStorage ?? null;
  }
}
